import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", null, "Company", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, "Description", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Period", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Position", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", null, [
    _hoisted_1,
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.company) = $event)),
      type: "text"
    }, null, 512), [
      [_vModelText, _ctx.company]
    ]),
    _hoisted_2,
    _withDirectives(_createElementVNode("textarea", {
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.description) = $event)),
      name: "",
      id: "",
      cols: "30",
      rows: "10"
    }, null, 512), [
      [_vModelText, _ctx.description]
    ]),
    _hoisted_3,
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.period) = $event)),
      type: "text"
    }, null, 512), [
      [_vModelText, _ctx.period]
    ]),
    _hoisted_4,
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.position) = $event)),
      type: "text"
    }, null, 512), [
      [_vModelText, _ctx.position]
    ]),
    _createElementVNode("button", {
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addData && _ctx.addData(...args)))
    }, "Submit"),
    _createElementVNode("p", null, "Company: " + _toDisplayString(_ctx.company), 1),
    _createElementVNode("p", null, "Description: " + _toDisplayString(_ctx.description), 1),
    _createElementVNode("p", null, "Period: " + _toDisplayString(_ctx.period), 1),
    _createElementVNode("p", null, "Position: " + _toDisplayString(_ctx.position), 1)
  ]))
}